import { MediaEntity } from '@/pages/AdvancedEditor/components/panels/media/types';
import { getMedia } from '@/services/api';
import { useAuth } from '@/services/auth';
import { useEffect } from 'react';
import { useQuery } from 'react-query';

export const GET_MEDIA_KEY = 'GET_MEDIA_KEY';

export const useMedia = () => {
    const { isAnonymous } = useAuth();

    const {
        data = [],
        isLoading,
        refetch,
    } = useQuery(GET_MEDIA_KEY, getMedia, {
        enabled: !isAnonymous,
    });

    useEffect(() => {
        if (isAnonymous) return;

        const intervalId = setInterval(() => {
            const hasPendingThumbnails = data.some(m => !m.thumbnail_ready);
            if (hasPendingThumbnails) {
                refetch();
            } else {
                clearInterval(intervalId);
            }
        }, 5000);

        return () => clearInterval(intervalId);
    }, [data, isAnonymous, refetch]);

    const mappedData: MediaEntity[] = data
        .sort((a, b) => b.created_at.localeCompare(a.created_at))
        .map(m => ({
            id: m.id,
            height: m.height,
            width: m.width,
            mimetype: m.mime_type,
            thumbnail: m.thumbnail_url || '',
            isLoading: !m.thumbnail_ready,
            filename: m.file_name,
            src: m.source_url,
            duration: m.duration_ms,
            createdAt: m.created_at,
        }))
        .filter(m => !m.isLoading);

    return { data: mappedData, isLoading };
};
